import React from 'react';
import { useTheme } from '@mui/material/styles';
import {Divider, Typography} from '@mui/material';

import Container from '../../components/Container';
import Main from '../../layouts/Main';
import FeaturedLegalServices from './components/FeaturedLegalServices';
import LegalLibraryList from './components/LegalLibrayList';
import LegalQuestionList from './components/LegalQuestionList';
import PageBreadCrumbs from '../../components/PageBreadcrumbs';


const Legal = (): JSX.Element => {
  const theme = useTheme();
  
  document.title = 'OCPF - Legal Resources';

  return (
    <Main>
      <Container>
      <PageBreadCrumbs></PageBreadCrumbs>
        <Typography
            variant="h5"
            align={'left'}
            sx={{
                fontWeight: 700,
            }}
            paddingTop={4}
            paddingBottom={2}
            >
            Legal Resources
        </Typography>
        <Divider/>
       <FeaturedLegalServices></FeaturedLegalServices>
       <Divider/>
       <LegalQuestionList></LegalQuestionList>
       <Divider/>
       <LegalLibraryList></LegalLibraryList>
      </Container>
    </Main>
  );
};

export default Legal;
